package com.evoapps.evoshift.ui.roster

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.selection.toggleable
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AutoFixHigh
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.schedule.AssignmentReason
import com.evoapps.evoshift.domain.schedule.AssignmentSource
import com.evoapps.evoshift.domain.schedule.DropReason
import com.evoapps.evoshift.domain.schedule.DroppedProposal
import androidx.compose.material.icons.filled.AutoAwesome
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.ButtonDefaults
import androidx.compose.foundation.BorderStroke
import evoshift.composeapp.generated.resources.auto_assign_ai_badge
import evoshift.composeapp.generated.resources.auto_assign_ai_dropped
import evoshift.composeapp.generated.resources.auto_assign_ai_dropped_because
import evoshift.composeapp.generated.resources.auto_assign_ai_dropped_duplicate
import evoshift.composeapp.generated.resources.auto_assign_ai_dropped_shift
import evoshift.composeapp.generated.resources.auto_assign_ai_dropped_shift_not_open
import evoshift.composeapp.generated.resources.auto_assign_ai_dropped_unknown_alias
import evoshift.composeapp.generated.resources.auto_assign_ai_dropped_unknown_person
import evoshift.composeapp.generated.resources.auto_assign_ai_planning
import evoshift.composeapp.generated.resources.auto_assign_ai_privacy
import evoshift.composeapp.generated.resources.auto_assign_ai_suggest
import evoshift.composeapp.generated.resources.auto_assign_ai_used
import com.evoapps.evoshift.domain.schedule.PlannedAssignment
import com.evoapps.evoshift.domain.schedule.SchedulePlan
import com.evoapps.evoshift.domain.schedule.ScheduleReason
import com.evoapps.evoshift.domain.schedule.ScheduleWarning
import com.evoapps.evoshift.domain.schedule.UnfilledShift
import com.evoapps.evoshift.domain.schedule.WarningKind
import com.evoapps.evoshift.domain.model.TimeRange
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.dayShort
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.viewmodels.AutoAssignUiState
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.EvoBottomSheet
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.ErrorOnNavy
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.auto_assign_apply
import evoshift.composeapp.generated.resources.auto_assign_gap_absent
import evoshift.composeapp.generated.resources.auto_assign_gap_staff_check_expired
import evoshift.composeapp.generated.resources.auto_assign_gap_already_working_that_day
import evoshift.composeapp.generated.resources.auto_assign_gap_busy_elsewhere
import evoshift.composeapp.generated.resources.auto_assign_gap_insufficient_rest
import evoshift.composeapp.generated.resources.auto_assign_gap_needs_non_lead
import evoshift.composeapp.generated.resources.auto_assign_gap_needs_shift_lead
import evoshift.composeapp.generated.resources.auto_assign_gap_needs_supervision
import evoshift.composeapp.generated.resources.auto_assign_gap_no_availability
import evoshift.composeapp.generated.resources.auto_assign_gap_no_staff
import evoshift.composeapp.generated.resources.auto_assign_gap_no_target_hours
import evoshift.composeapp.generated.resources.auto_assign_gap_not_qualified
import evoshift.composeapp.generated.resources.auto_assign_gap_outside_preferred_slot
import evoshift.composeapp.generated.resources.auto_assign_gap_overlaps_own_shift
import evoshift.composeapp.generated.resources.auto_assign_gap_personal_constraint
import evoshift.composeapp.generated.resources.auto_assign_gap_person
import evoshift.composeapp.generated.resources.auto_assign_gap_target_reached
import evoshift.composeapp.generated.resources.auto_assign_gap_too_many_consecutive_days
import evoshift.composeapp.generated.resources.auto_assign_gap_no_weekly_rest
import evoshift.composeapp.generated.resources.auto_assign_gap_labour_hours_limit
import evoshift.composeapp.generated.resources.auto_assign_gap_unavailable
import evoshift.composeapp.generated.resources.auto_assign_intro
import evoshift.composeapp.generated.resources.auto_assign_nothing_to_fill
import evoshift.composeapp.generated.resources.auto_assign_people
import evoshift.composeapp.generated.resources.auto_assign_person_hours
import evoshift.composeapp.generated.resources.auto_assign_person_hours_target
import evoshift.composeapp.generated.resources.auto_assign_planning
import evoshift.composeapp.generated.resources.auto_assign_proposed
import evoshift.composeapp.generated.resources.auto_assign_select_all
import evoshift.composeapp.generated.resources.auto_assign_select_none
import evoshift.composeapp.generated.resources.auto_assign_targets_not_used
import evoshift.composeapp.generated.resources.auto_assign_title
import evoshift.composeapp.generated.resources.auto_assign_unfilled
import evoshift.composeapp.generated.resources.auto_assign_warn_kept_breaks_rule
import evoshift.composeapp.generated.resources.auto_assign_warn_first_roster
import evoshift.composeapp.generated.resources.auto_assign_warn_no_availability
import evoshift.composeapp.generated.resources.auto_assign_warn_no_leads
import evoshift.composeapp.generated.resources.auto_assign_warn_days_without_lead
import evoshift.composeapp.generated.resources.auto_assign_warn_other_workplaces
import evoshift.composeapp.generated.resources.auto_assign_warn_pay_terms
import evoshift.composeapp.generated.resources.auto_assign_warn_range
import evoshift.composeapp.generated.resources.auto_assign_why_after_long_break
import evoshift.composeapp.generated.resources.auto_assign_why_balanced_hours
import evoshift.composeapp.generated.resources.auto_assign_why_below_target
import evoshift.composeapp.generated.resources.auto_assign_why_best_fit
import evoshift.composeapp.generated.resources.auto_assign_why_extends_run
import evoshift.composeapp.generated.resources.auto_assign_why_non_lead_needed
import evoshift.composeapp.generated.resources.auto_assign_why_owner_morning
import evoshift.composeapp.generated.resources.auto_assign_why_preferred_slot
import evoshift.composeapp.generated.resources.auto_assign_why_scarce_availability
import evoshift.composeapp.generated.resources.auto_assign_why_shift_lead_needed
import kotlinx.datetime.LocalDate
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/**
 * SH-53: the auto-assign preview of the roster builder. The rules' proposals for the month's
 * unassigned shifts (each kept or dropped with its checkbox), the shifts nobody can take with the
 * reason, everyone's hours before and after, and Assign for the kept ones. Nothing is written
 * before Assign; closing the sheet drops the proposal.
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AutoAssignSheet(
    state: AutoAssignUiState,
    onToggle: (String) -> Unit,
    onSelectAll: (Boolean) -> Unit,
    onApply: () -> Unit,
    onDismiss: () -> Unit,
    /** SH-90: plan again with AI suggestions (offered only when [AutoAssignUiState.aiOffered]). */
    onSuggestWithAi: () -> Unit = {}
) {
    val plan = state.plan
    EvoBottomSheet(
        onDismiss = onDismiss,
        title = stringResource(Res.string.auto_assign_title),
        icon = Icons.Default.AutoFixHigh
    ) {
        if (state.isPlanning || plan == null) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                CircularProgressIndicator(modifier = Modifier.size(24.dp), color = DarkGold, strokeWidth = 3.dp)
                Spacer(Modifier.width(16.dp))
                Text(
                    stringResource(if (state.usedAi) Res.string.auto_assign_ai_planning else Res.string.auto_assign_planning),
                    color = Color.White.copy(alpha = 0.85f)
                )
            }
            return@EvoBottomSheet
        }
        Text(stringResource(Res.string.auto_assign_intro), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.7f))
        if (state.targetsNotUsed) {
            Text(stringResource(Res.string.auto_assign_targets_not_used), style = MaterialTheme.typography.bodySmall, color = LightGold)
        }
        // SH-90: the AI option with what is sent, then how the AI went.
        if (state.aiOffered && (!state.usedAi || state.aiFallback != null) && plan.shiftsToFill > 0) {
            AiOption(onSuggestWithAi)
        }
        state.aiFallback?.asString()?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = LightGold) }
        if (state.usedAi && state.aiFallback == null) {
            Text(stringResource(Res.string.auto_assign_ai_used), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.7f))
        }
        val names = plan.staff.associate { it.userId to it.displayName }
        plan.warnings.forEach { warning -> warningText(warning, names)?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = LightGold) } }

        if (plan.shiftsToFill == 0) {
            Text(stringResource(Res.string.auto_assign_nothing_to_fill), color = Color.White.copy(alpha = 0.85f))
            return@EvoBottomSheet
        }

        if (plan.assignments.isNotEmpty()) {
            Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth()) {
                SectionTitle(stringResource(Res.string.auto_assign_proposed, plan.assignments.size), Modifier.weight(1f))
                val all = state.acceptedCount == plan.assignments.size
                TextButton(onClick = { onSelectAll(!all) }, modifier = Modifier.handCursor()) {
                    Text(stringResource(if (all) Res.string.auto_assign_select_none else Res.string.auto_assign_select_all), color = LightGold)
                }
            }
            plan.assignments.forEach { proposal ->
                ProposalRow(proposal, checked = proposal.shiftId in state.accepted, onToggle = { onToggle(proposal.shiftId) })
            }
        }

        if (plan.unfilled.isNotEmpty()) {
            SectionTitle(stringResource(Res.string.auto_assign_unfilled, plan.unfilled.size))
            plan.unfilled.forEach { UnfilledRow(it) }
        }

        if (plan.dropped.isNotEmpty()) {
            SectionTitle(stringResource(Res.string.auto_assign_ai_dropped, plan.dropped.size))
            plan.dropped.forEach { DroppedRow(it, plan, names) }
        }

        val people = plan.staff.filter { it.newShifts > 0 }
        if (people.isNotEmpty()) {
            SectionTitle(stringResource(Res.string.auto_assign_people))
            people.forEach { person ->
                val before = hours(person.hoursBefore)
                val after = hours(person.hoursAfter)
                val line = person.target.hours?.let { target ->
                    stringResource(Res.string.auto_assign_person_hours_target, before, after, hours(target))
                } ?: stringResource(Res.string.auto_assign_person_hours, before, after)
                Row(Modifier.fillMaxWidth()) {
                    Text(person.displayName, modifier = Modifier.weight(1f), color = Color.White, fontWeight = FontWeight.SemiBold)
                    Text(line, color = Color.White.copy(alpha = 0.75f))
                }
            }
        }

        EvoPrimaryButton(
            DialogAction(
                label = stringResource(Res.string.auto_assign_apply, state.acceptedCount),
                onClick = onApply,
                enabled = state.acceptedCount > 0
            ),
            modifier = Modifier.fillMaxWidth()
        )
    }
}

@Composable
private fun SectionTitle(text: String, modifier: Modifier = Modifier) {
    Text(
        text.uppercase(),
        modifier = modifier.padding(top = 8.dp),
        style = MaterialTheme.typography.labelMedium,
        fontWeight = FontWeight.Bold,
        color = LightGold
    )
}

/** "Mon 2 · 07:00 – 15:00". */
@Composable
private fun whenText(date: String, time: TimeRange): String {
    val day = LocalDate.parse(date)
    return "${dayShort(day.dayOfWeek)} ${day.day} · ${time.start.substring(11, 16)} – ${time.end.substring(11, 16)}"
}

@Composable
private fun ProposalRow(proposal: PlannedAssignment, checked: Boolean, onToggle: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White.copy(alpha = if (checked) 0.08f else 0.03f))
            .handCursor()
            .toggleable(value = checked, role = Role.Checkbox, onValueChange = { onToggle() })
            .padding(horizontal = 8.dp, vertical = 6.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Checkbox(
            checked = checked,
            onCheckedChange = null,
            colors = CheckboxDefaults.colors(checkedColor = DarkGold, uncheckedColor = Color.White.copy(alpha = 0.5f))
        )
        Spacer(Modifier.width(8.dp))
        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(proposal.displayName, color = Color.White, fontWeight = FontWeight.Bold)
                if (proposal.source == AssignmentSource.AI) AiBadge()
            }
            Text(whenText(proposal.date, proposal.plannedTime), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.8f))
            proposal.reasons.firstOrNull()?.let {
                Text(stringResource(it.labelRes()), style = MaterialTheme.typography.labelSmall, color = LightGold)
            }
        }
    }
}

/** SH-90: "Suggest with AI" and what leaves the device. */
@Composable
private fun AiOption(onClick: () -> Unit) {
    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
        OutlinedButton(
            onClick = onClick,
            modifier = Modifier.handCursor(),
            border = BorderStroke(1.dp, LightGold),
            colors = ButtonDefaults.outlinedButtonColors(contentColor = LightGold)
        ) {
            Icon(Icons.Default.AutoAwesome, contentDescription = null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Text(stringResource(Res.string.auto_assign_ai_suggest))
        }
        Text(stringResource(Res.string.auto_assign_ai_privacy), style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.6f))
    }
}

/** SH-90: marks a proposal the AI made (and every hard rule passed). */
@Composable
private fun AiBadge() {
    Text(
        stringResource(Res.string.auto_assign_ai_badge),
        modifier = Modifier
            .clip(RoundedCornerShape(6.dp))
            .background(DarkGold)
            .padding(horizontal = 6.dp, vertical = 1.dp),
        style = MaterialTheme.typography.labelSmall,
        fontWeight = FontWeight.Bold,
        color = Color.Black
    )
}

/** SH-90: an AI proposal that was not used: whom, when, and the rule or reason that stopped it. */
@Composable
private fun DroppedRow(drop: DroppedProposal, plan: SchedulePlan, names: Map<String, String>) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White.copy(alpha = 0.03f))
            .padding(horizontal = 12.dp, vertical = 8.dp),
        verticalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        val shift = plan.assignments.firstOrNull { it.shiftId == drop.shiftId }?.let { it.date to it.plannedTime }
            ?: plan.unfilled.firstOrNull { it.shiftId == drop.shiftId }?.let { it.date to it.plannedTime }
        val time = shift?.let { whenText(it.first, it.second) } ?: stringResource(Res.string.auto_assign_ai_dropped_shift)
        val who = drop.userId?.let { names[it] }
        Text(who?.let { "$it · $time" } ?: time, color = Color.White)
        val why = when (drop.reason) {
            DropReason.BREAKS_RULE -> (drop.rule ?: ScheduleReason.PERSONAL_CONSTRAINT).labelRes()
            DropReason.UNKNOWN_ALIAS -> Res.string.auto_assign_ai_dropped_unknown_alias
            DropReason.SHIFT_NOT_OPEN -> Res.string.auto_assign_ai_dropped_shift_not_open
            DropReason.UNKNOWN_PERSON -> Res.string.auto_assign_ai_dropped_unknown_person
            DropReason.DUPLICATE -> Res.string.auto_assign_ai_dropped_duplicate
        }
        Text(
            stringResource(Res.string.auto_assign_ai_dropped_because, stringResource(why)),
            style = MaterialTheme.typography.labelSmall,
            color = ErrorOnNavy
        )
    }
}

@Composable
private fun UnfilledRow(gap: UnfilledShift) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White.copy(alpha = 0.03f))
            .padding(horizontal = 12.dp, vertical = 8.dp),
        verticalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        val time = whenText(gap.date, gap.plannedTime)
        Text(gap.requiredRole?.takeIf { it.isNotBlank() }?.let { "$it · $time" } ?: time, color = Color.White)
        Text(stringResource(gap.reason.labelRes()), style = MaterialTheme.typography.labelSmall, color = ErrorOnNavy)
        // Who came closest, when it is not the team's reason: what would have to change.
        gap.closest?.takeIf { it.reason != gap.reason }?.let { closest ->
            Text(
                stringResource(Res.string.auto_assign_gap_person, closest.displayName, stringResource(closest.reason.labelRes())),
                style = MaterialTheme.typography.labelSmall,
                color = Color.White.copy(alpha = 0.7f)
            )
        }
    }
}

@Composable
private fun warningText(warning: ScheduleWarning, names: Map<String, String>): String? {
    val who = warning.userIds.map { names[it] ?: it }.sorted().joinToString(", ")
    return when (warning.kind) {
        WarningKind.NO_AVAILABILITY_SUBMITTED -> stringResource(Res.string.auto_assign_warn_no_availability, who)
        WarningKind.FIRST_ROSTER_WITHOUT_AVAILABILITY -> stringResource(Res.string.auto_assign_warn_first_roster, who)
        WarningKind.PAY_TERMS_UNREADABLE -> stringResource(Res.string.auto_assign_warn_pay_terms, who)
        WarningKind.OTHER_WORKPLACES_UNREADABLE -> stringResource(Res.string.auto_assign_warn_other_workplaces, who)
        WarningKind.RANGE_CLAMPED -> stringResource(Res.string.auto_assign_warn_range)
        WarningKind.NO_SHIFT_LEADS -> stringResource(Res.string.auto_assign_warn_no_leads)
        WarningKind.KEPT_ASSIGNMENT_BREAKS_RULE -> stringResource(Res.string.auto_assign_warn_kept_breaks_rule)
        WarningKind.DAYS_WITHOUT_LEAD -> stringResource(Res.string.auto_assign_warn_days_without_lead, warning.shiftIds.size)
    }
}

private fun hours(value: Double): String =
    if (value % 1.0 == 0.0) value.toInt().toString() else ((value * 10).toInt() / 10.0).toString()

/** Why the rules chose the person (the first reason is the step that decided it). */
internal fun AssignmentReason.labelRes(): StringResource = when (this) {
    AssignmentReason.OWNER_MORNING -> Res.string.auto_assign_why_owner_morning
    AssignmentReason.SHIFT_LEAD_NEEDED -> Res.string.auto_assign_why_shift_lead_needed
    AssignmentReason.NON_LEAD_NEEDED -> Res.string.auto_assign_why_non_lead_needed
    AssignmentReason.BEST_FIT -> Res.string.auto_assign_why_best_fit
    AssignmentReason.BALANCED_HOURS -> Res.string.auto_assign_why_balanced_hours
    AssignmentReason.SCARCE_AVAILABILITY -> Res.string.auto_assign_why_scarce_availability
    AssignmentReason.BELOW_TARGET -> Res.string.auto_assign_why_below_target
    AssignmentReason.EXTENDS_RUN -> Res.string.auto_assign_why_extends_run
    AssignmentReason.AFTER_LONG_BREAK -> Res.string.auto_assign_why_after_long_break
    AssignmentReason.PREFERRED_SLOT -> Res.string.auto_assign_why_preferred_slot
}

/** Why a shift stays empty (the most common reason among the team). */
internal fun ScheduleReason.labelRes(): StringResource = when (this) {
    ScheduleReason.NO_STAFF -> Res.string.auto_assign_gap_no_staff
    ScheduleReason.NOT_QUALIFIED -> Res.string.auto_assign_gap_not_qualified
    ScheduleReason.NO_TARGET_HOURS -> Res.string.auto_assign_gap_no_target_hours
    ScheduleReason.ABSENT -> Res.string.auto_assign_gap_absent
    ScheduleReason.STAFF_CHECK_EXPIRED -> Res.string.auto_assign_gap_staff_check_expired
    ScheduleReason.UNAVAILABLE -> Res.string.auto_assign_gap_unavailable
    ScheduleReason.NO_AVAILABILITY -> Res.string.auto_assign_gap_no_availability
    ScheduleReason.OUTSIDE_PREFERRED_SLOT -> Res.string.auto_assign_gap_outside_preferred_slot
    ScheduleReason.PERSONAL_CONSTRAINT -> Res.string.auto_assign_gap_personal_constraint
    ScheduleReason.OVERLAPS_OWN_SHIFT -> Res.string.auto_assign_gap_overlaps_own_shift
    ScheduleReason.BUSY_ELSEWHERE -> Res.string.auto_assign_gap_busy_elsewhere
    ScheduleReason.ALREADY_WORKING_THAT_DAY -> Res.string.auto_assign_gap_already_working_that_day
    ScheduleReason.INSUFFICIENT_REST -> Res.string.auto_assign_gap_insufficient_rest
    ScheduleReason.TOO_MANY_CONSECUTIVE_DAYS -> Res.string.auto_assign_gap_too_many_consecutive_days
    ScheduleReason.NO_WEEKLY_REST -> Res.string.auto_assign_gap_no_weekly_rest
    ScheduleReason.LABOUR_HOURS_LIMIT -> Res.string.auto_assign_gap_labour_hours_limit
    ScheduleReason.TARGET_REACHED -> Res.string.auto_assign_gap_target_reached
    ScheduleReason.NEEDS_SHIFT_LEAD -> Res.string.auto_assign_gap_needs_shift_lead
    ScheduleReason.NEEDS_NON_LEAD -> Res.string.auto_assign_gap_needs_non_lead
    ScheduleReason.NEEDS_SUPERVISION -> Res.string.auto_assign_gap_needs_supervision
}
